import * as types from '../mutation-types';
import axios from '@/axios';

export default {
	namespaced: true,
	state: {
		classSubjects: [],
		subSubjects: [],
	},
	
	actions: {
		fetchByClassId({ commit, state }, { classId, isForceUpdate = false }) {
			const index = state.classSubjects.findIndex(c => c.classId === classId);
			
			if (index === -1 || isForceUpdate) {
				return axios.get('/subject/brief', { params: { specialtyId: classId } }).then(({ data }) => {
					commit(types.STORE_CLASS_SUBJECTS, { classId, subjects: data });
					return data
				});
			} else {
				return new Promise((resolve) => {
					resolve(state.classSubjects[index].subjects);
				})
			}
		},

		updateScales({ commit }, { subjectId, scales }) {
			return axios.post(
				'/subject/scales',
				scales.map((c, i) => ({ orderIndex: i, code: c })),
				{ params: { subjectId } }
			);
		}
	},

	mutations: {
		[types.STORE_CLASS_SUBJECTS] (state, { classId, subjects }) {
			state.classSubjects.push({ classId, subjects });
			state.subSubjects = state.classSubjects.flatMap(c => c.subjects).flatMap(c =>
				c.subjectChilds.map(e => ({ ...e, parent: c.name, parentId: c.id }))
			);
		}
	},

	getters: {
		getSubSubjectById: state => id => state.subSubjects.find(c => c.id === id),
	}
}